module.exports = __webpack_public_path__ + "74c3770eaf5a80568c651b1f8e54a96f.png";